module.exports = __webpack_public_path__ + "static/media/emerge_icon.dabf1aaf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/emerge_icon.png
// module id = 820
// module chunks = 0